<template>
    <img src="/images/promo/hero-section/key.png"
     alt="Key" />
</template>

<script>
export default {};
</script>
